import React, { PropsWithChildren } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getFeatureFlags } from './FeatureFlagService';
import { FEATURE_FLAGS_MODULES } from './FeatureFlags.models';
import { FeatureFlagContext } from 'src/featureFlags/FeatureFlagContext';

export const FeatureFlagProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { data } = useQuery({
    queryKey: ['feature', 'flags'],
    queryFn: () => {
      return getFeatureFlags();
    },
    retry: 0,
    gcTime: 0,
    // suspense: false,
  });

  return data ? (
    <FeatureFlagContext.Provider
      value={
        data || {
          [FEATURE_FLAGS_MODULES.SIM_INVENTORY]: {},
          [FEATURE_FLAGS_MODULES.BULK_PROVISIONING]: {},
          [FEATURE_FLAGS_MODULES.AUDIT_TRAIL]: {},
        }
      }
    >
      {children}
    </FeatureFlagContext.Provider>
  ) : null;
};
